import classes from 'dom-helpers/class';
import create from 'dom-create-element';
import gsap from 'gsap';
import { handleEvent } from '../base/utils';
import Component from './component';

class Slideshow extends Component {
    constructor(selector, opts) {
        super(selector, opts);

        // una lista di nodi non è un array *****
        this.ui = Object.assign({}, this.ui, {
            slides: this.qsa('.next-image'),
            current: this.qsa('[data-slide="active"]'),
            next: this.qsa('[data-next]'),
            currentNumber: this.qs('[data-current]'),
            totalNumber: this.qs('[data-total]'),
        });

        this.currentIndex = -1;
        this.isAnimating = false;
        this.totalSlides = this.ui.slides.length;
        this.slug = opts.slug;
        this.id = opts.id;
        this.tl = new TimelineMax({
            onComplete: () => {
                this.currentIndex = this.nextIndex;
                this.isAnimating = false;
            },
        });
    }

    bind() {
        this.next = [];

        this.ui.next.forEach((el) => {
            const handle = handleEvent('click', {
                onElement: el,
                withCallback: () => {
                    if (!this.isAnimating) {
                        this.scrollToSection(1, true);
                    }
                },
            });

            this.next.push(handle);
        })
    }

    init() {
        this.bind();
        this.currentIndex = 0;
        this.nextIndex = 0;
        this.$currentSection = this.ui.slides[this.nextIndex];
        this.$nextSection = this.ui.slides[this.nextIndex];

        gsap.set(this.ui.slides, { xPercent: -100 });
        gsap.set(this.$currentSection, { xPercent: 0, display: 'block' });

        // update numbers
        this.ui.currentNumber.innerHTML = `0${this.nextIndex + 1}`;
        this.ui.totalNumber.innerHTML = `0${this.totalSlides}`;


        classes.addClass(this.$nextSection, 'is-active');
        // this.animateSections(1, true);
    }

    stop() {
        this.next.forEach((el) => {
            el.destroy();
        });

        this.isAnimating = false;
    }

    scrollToSection(factor) {

        if (this.currentIndex + factor >= this.ui.slides.length) {
            this.nextIndex = 0;
        } else {
            this.nextIndex += factor;
        }

        this.$currentSection = this.ui.slides[this.currentIndex];
        this.$nextSection = this.ui.slides[this.nextIndex];
        this.activeElements(factor);
    }

    activeElements(factor) {
        // change next index and slides
        this.$currentSection = this.ui.slides[this.currentIndex];
        this.$nextSection = this.ui.slides[this.nextIndex];

        // starting animation
        this.animateSections(factor, false);
    }

    animateSections(factor) {
        if (this.isAnimating) {
            return;
        }

        this.isAnimating = true;

        // update current number
        this.ui.currentNumber.innerHTML = `0${this.nextIndex + 1}`;

        const currentUrl = this.$currentSection.getAttribute('data-background');
        const nextUrl = this.$nextSection.getAttribute('data-background');
        const oldElement = this.ui.container.querySelectorAll('.slider-image__wrapper');
        const newElement = [];

        this.ui.current.forEach((el) => {
            const element = create({
                selector: 'div',
                styles: 'slider-image__wrapper is-active',
                children: create({
                    selector: 'img',
                    attr: {
                        src: currentUrl,
                    },
                }),
            });

            gsap.set(element, {
                zIndex: 1,
                backgroundImage: `url(${currentUrl})`,
                xPercent: -100,
                onComplete: () => {
                    el.appendChild(element);
                    newElement.push(element);
                },
            });
        });

        // animate everything
        this.tl.set(this.$currentSection, {
            zIndex: 1,
        }).set(this.$nextSection, {
            xPercent: 0,
            zIndex: 0,
            display: 'block',
            className: '+=is-active',
            clearProps: 'transform',
        }).to(this.$currentSection, 1, {
            xPercent: 100,
            ease: Power4.easeOut,
            className: '-=is-active',
            clearProps: 'transform, z-index, display',
        }).staggerTo(newElement, 1, {
            xPercent: 0,
            ease: Power4.easeOut,
            onComplete: () => {
                oldElement.forEach((el) => {
                    el.remove();
                });
            },
        }, 0.2, '-=0.9');
    }

    destroy() {
        this.stop();
    }
}

export default Slideshow;



/** WEBPACK FOOTER **
 ** ./components/slideshow.js
 **/